import React from 'react'

const NewsletterContentImage = ({url, alt, width, align="Left", valign="top", addClass="", tdStyles={}, imgStyles={}}) => (
    <td className={"imageContent" + (addClass ? ' ' + addClass : '')} style={{fontSize: '0px', lineHeight: 0, ...tdStyles}} align={align} valign={valign}>
        <img className="flexibleImage" alt={alt} src={(url ? url : '')} width={width}  style={{maxWidth: width + 'px', ...imgStyles}}/>
    </td>
)

export default NewsletterContentImage